// DUPLICATED — keep in sync with src/webform/components/ContentWrapper/ContentWrapper.tsx (monolith).
// Can't be shared via path alias: a file under src/ resolves react@16/styled-components@5,
// while this workspace needs react@19/styled-components@6. Mirror every change on both
// sides until the monolith webform is decommissioned.
import {type PropsWithChildren} from "react";

import * as Styled from "./contentWrapper.styled";

interface OwnProps {
    fullHeight?: boolean;
}

export const ContentWrapper = ({children, fullHeight}: PropsWithChildren<OwnProps>) => (
    <Styled.ContentWrapper>
        <Styled.Content $fullHeight={fullHeight}>{children}</Styled.Content>
    </Styled.ContentWrapper>
);
